import { createStructuredSelector } from "reselect";
import { getAccountSelectedPositionInfo } from "../../../../../modules/Account/accountSelectors";
import { connect } from "react-redux";
import { MobileHistoryInfoIconWrapperStyled } from "../../styled/MobileHistoryInfoStyled";
import { BinIcon, IconAsset } from "../../../../../components/icon/Icon";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";
import { LITE_TRADE_POSITION_SIDE } from "../../../../../modules/LiteTrade/liteTradeConstants";
import { getLiteTradeAssetsBySymbol } from "../../../../../modules/LiteTrade/liteTradeSelectors";
import classNames from "classnames";
import amountFormat from "../../../../../utils/amountFormat";
import {
    MobileHistoryInfoAmountStyled,
    MobileHistoryInfoDividerStyled
} from "./styled/MobileHistoryPositionInfoStyled";
import { Loader } from "../../../../../components/Loader/Loader";
import { useCallback } from "react";

function MobileHistoryPositionInfo(props) {
    const {assetsBySymbol, selectedPositionInfo} = props;
    const {getLangPath} = useLangContext();
    const asset = assetsBySymbol[selectedPositionInfo.symbol];
    const lotsAmount = selectedPositionInfo?.quantity / asset?.info?.lotSize;

    const handleCopyToClipboardTransactionID = useCallback(() => {
        navigator.clipboard.writeText(selectedPositionInfo?.position_code).then();
    }, [selectedPositionInfo]);

    if (!asset) {
        return <Loader show/>
    }

    return <div className="d-flex flex-column align-items-center px-3">
        <MobileHistoryInfoIconWrapperStyled>
            <IconAsset symbol={selectedPositionInfo.symbol}/>
        </MobileHistoryInfoIconWrapperStyled>
        <h4 className="f16">
            {
                !!asset?.info?.description && getLangPath(selectedPositionInfo.side === LITE_TRADE_POSITION_SIDE.BUY
                        ? 'lite_version.history.bought_asset'
                        : 'lite_version.history.sold_asset',
                    {asset: asset.info.description})
            }
        </h4>
        <div className="color-white-60">
            {selectedPositionInfo.symbol}
        </div>
        <MobileHistoryInfoAmountStyled className={classNames('f24', {
            'negative': selectedPositionInfo.pl < 0,
            'positive': selectedPositionInfo.pl > 0,
        })}>
            {amountFormat(selectedPositionInfo.pl, 2, '$')}
        </MobileHistoryInfoAmountStyled>
        <div className="d-flex justify-content-between w-100 f16 mt-5">
            <div className="color-white-60">
                {getLangPath('lite_version.order.amount')}
            </div>
            <div>
                {getLangPath('lite_version.order.lots_count', {number: lotsAmount})}
            </div>
        </div>
        <MobileHistoryInfoDividerStyled/>
        <div className="d-flex justify-content-between w-100 f16">
            <div className="color-white-60">
                {getLangPath('lite_version.history.position_id')}
            </div>
            <div onClick={handleCopyToClipboardTransactionID} className="d-flex align-items-center">
                {selectedPositionInfo.position_code}
                <BinIcon name="IcDocCopy" className="ms-2" style={{fill: 'color-white-60'}}/>
            </div>
        </div>
    </div>
}

const mapStateToProps = createStructuredSelector({
    assetsBySymbol: getLiteTradeAssetsBySymbol,
    selectedPositionInfo: getAccountSelectedPositionInfo,
});

export default connect(mapStateToProps)(MobileHistoryPositionInfo);
